const ArticleExchangeList = () => import('Views/articleExchange/articleExchange-list-new-ui');
const ArticleExchangeEdit = () => import('Views/articleExchange/articleExchange-edit-new-ui');
const ArticleExchangeDetail = () => import('Views/articleExchange/articleExchange-detail-new-ui');

export default[
  { path: '/articleExchange-list', component: ArticleExchangeList },
  { path: '/articleExchange-list', component: ArticleExchangeList },
  { path: '/articleExchange-edit/:id', component: ArticleExchangeEdit },
  { path: '/articleExchange-detail/:id', component: ArticleExchangeDetail },
];



// WEBPACK FOOTER //
// ./src/router/articleExchange.js